var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoverPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 295,
    viewBox: "0 0 466 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707397,
    y: 0.271362,
    width: 464.593,
    height: 294.175,
    rx: 8,
    fill: "#D8D8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.376 127.021C231.76 127.021 227.207 122.468 227.207 116.852C227.207 111.236 231.76 106.683 237.376 106.683C242.992 106.683 247.545 111.236 247.545 116.852C247.539 122.465 242.99 127.015 237.376 127.021Z",
    fill: "#D8D8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.662 79.5659H179.752C168.534 79.5987 159.447 88.6851 159.415 99.9037V159.968L185.718 133.665C193.768 126.004 206.412 126.004 214.462 133.665L233.928 153.236L239.945 147.22C247.9 139.311 260.749 139.311 268.704 147.22L295 173.516V99.9037C294.967 88.6851 285.881 79.5987 274.662 79.5659ZM237.376 127.021C231.76 127.021 227.207 122.468 227.207 116.852C227.207 111.236 231.76 106.683 237.376 106.683C242.992 106.683 247.545 111.236 247.545 116.852C247.539 122.465 242.99 127.015 237.376 127.021Z",
    fill: "#B2B1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.462 133.665C206.412 126.004 193.768 126.004 185.718 133.665L159.415 159.968V194.814C159.447 206.032 168.534 215.119 179.752 215.151H274.662C280.188 215.149 285.475 212.897 289.305 208.914L214.462 133.665Z",
    fill: "#6563FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295 173.516L268.704 147.22C260.749 139.311 247.9 139.311 239.945 147.22L233.928 153.236L289.276 208.884C292.951 205.123 295.006 200.072 295 194.814V173.516Z",
    fill: "#8E8DDD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverPlaceholder);
export default __webpack_public_path__ + "static/media/coverPlaceholder.6209d38b85615d327273ed98556996b4.svg";
export { ForwardRef as ReactComponent };